import { motion } from 'motion/react';
import { Navigate } from 'react-router';
import { TallyLoader } from '../../../shared/components/tally-loader';
import { Wordmark } from '../../../shared/components/wordmark';
import { BOT_URL, BOT_USERNAME, ROUTES } from '../../../shared/constants/app.constant';
import { ThemeToggle } from '../../theme/components/theme-toggle';
import { LOGIN_STEPS } from '../constants/auth.constant';
import { useSession } from '../hooks/use-session';

export function LoginPage() {
  const { user, isLoading } = useSession();

  if (isLoading) return <TallyLoader label="Memeriksa sesi" className="p-8" />;
  if (user) return <Navigate to={ROUTES.dashboard} replace />;

  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-5xl flex-col px-5 py-6 md:px-10">
      <header className="flex items-center justify-between">
        <Wordmark />
        <ThemeToggle />
      </header>

      <div className="grid flex-1 items-center gap-10 py-12 md:grid-cols-[1.1fr_0.9fr] md:gap-16">
        <motion.section
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <h1 className="font-display-soft text-4xl leading-tight text-ink md:text-6xl">
            Buku kas yang kamu isi dari Telegram.
          </h1>
          <p className="mt-5 max-w-md text-base text-muted md:text-lg">
            Catat uang cash dengan mengetik <span className="text-ink">makan 25rb</span> ke bot. Di sini kamu
            melihat ke mana uangnya pergi, bersama orang yang kamu ajak.
          </p>
        </motion.section>

        <motion.section
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.12 }}
          className="rounded-card border border-rule bg-card p-6 md:p-8"
          aria-labelledby="login-title"
        >
          <h2 id="login-title" className="font-display text-xl text-ink">
            Masuk lewat bot
          </h2>
          <ol className="mt-5 flex flex-col gap-4">
            {LOGIN_STEPS.map((step, index) => (
              <li key={step} className="flex gap-3 text-sm text-ink">
                <span className="tabular font-display text-lg leading-5 text-muted">{index + 1}.</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
          <a
            href={BOT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-7 inline-flex min-h-11 w-full items-center justify-center rounded-field bg-brass px-4 text-sm font-medium text-brass-ink hover:brightness-95"
          >
            Buka @{BOT_USERNAME} di Telegram
          </a>
          <p className="mt-4 text-xs text-muted">
            Belum punya akun? Kirim /start ke bot, akunmu langsung dibuat.
          </p>
        </motion.section>
      </div>
    </main>
  );
}
